const zh = {
  items: "条",
  total: "共",
    begin : "开始",
    cancel: "取消",
    confirm: "确认",
    commit: "提交",
    commitSuccess: "提交成功！",
    exit: "退出",
    edit: "编辑",
    system: "系统设置",
    index: "序号",
    pleaseEnter: "请填写",
    pleaseSelect: "请选择",
    remark: "备注",
    operation: "操作",
    delete: "删除",
    add: "新增",
    submit: "提交",
    yes: "是",
    no: "否",
    quit: "放弃",
    uploadTip: "点击或拖拽文件到此处上传文件",
    deleteSuccess: "删除成功！",
    status: "状态",
    disabled: "禁用",
    enabled: "启用",
    pleaseUpload : "请上传",
    serviceStop: "暂停服务",
    notice: "通知公告",
    regulation: "注意事项",
    save: "保存",
    goBack: "返回上一页",
    submitAndCreate: "提交并继续添加",
    annex: "附件",
    uploadSuccess : "上传成功",
    speciesManage : "样本管理",
    moleculeManage : "小分子管理",
    regionLabel : "脑区标注",
    replaceRegion : "替换脑区",
    noPermission: "您没有权限访问此网站，如有疑问请联系遗传操作中心。",
    prohibitTime: "禁用时间为：",
    prohibitVisit: "您的账号已被禁用，如有疑问请联系遗传操作中心。",
    submitVisit: "申请访问",
    confirmVisit: "请确认是否提交访问申请？",
    waitPass: "您已提交访问申请，请耐心等待审核。如有疑问请联系遗传操作中心。",
    pleaseEnterPhone : "请填写手机号码",
    taskList : "任务列表",
    createNewTask : "创建新的服务",
    animalType : "动物种类",
    geneName : "基因名称",
    geneReplace: "基因替换",
    editType : "编辑类型",
    description : "详细描述",
    uploadFile : "上传附件",
    smallMouse : "小鼠",
    bigMouse : "大鼠",
    knockOut : "敲除",
    knockIn : "敲入",
    pointMutation : "点突变",
    conditionalKnockout : "条件性敲除",
    spotInsert : "定点插入",
    randomInsert : "随机插入",
    other : "其他",
    proxyOrder : "代理下单",
    otherEditType : "其他编辑类型",
    belongUser : "归属人",
    createTime : "创建时间",
    taskIndex : "订单编号",
    search : "搜索",
    reset : "重置",
    orderBy : "排序",
    detail : "详情",
    makeApply : "提出申请",
    produceProgrammes : "出具方案",
    molecularCloning : "分子克隆",
    cloneDetail:"sgRNA合成、分子克隆、质粒大提",
    microinjection : "显微注射",
    f0mice : "F0筛选",
    f1mice : "F1鉴定",
    ArrangeTransfer : "安排转运",
    ConfirmCompletion : "确认完成",
    nextStep : "下一步",
    completeTime : "完成时间",
    Programmes : "方案",
    hasComplete : "已完成",
    restart : "从此步骤重新开始",
    restartSuccess : "此任务已重新初始化！",
    history : "历史记录",
    goHome : "返回主页",
    phone : "手机号码",
    userManage : "用户管理",
    iKnow: "我知道了",
    taskStream : "任务流程",
    home: "在研项目",
    sendEmail: "发送通知邮件",
    orderCompleted: "此订单已完成!",
    user: {
        pass: "通过",
        band: "禁用",
        normal: "正常",
        waitPass: "等待审核",
        userManage: "用户管理",
        name: "姓名",
        group: "部门",
        banStart: "禁用开始时间",
        banEnd: "禁用结束时间",
        usertype: "用户权限",
        superUser: "高级用户",
        normalUser: "普通用户",
        labAdmin : "实验室管理员",
        PI : "PI",
        adminUser : "管理员",
        targetAdmin : "代谢物靶标分析管理员",
        nonTargetAdmin : "非靶标代谢组学分析管理员",
        proteinAdmin : "蛋白质组学分析管理员",
        ionicAdmin : "离子色谱管理员",
    },
    err: {
        bacteriaTip: "信息不完整！",
        E500: "系统异常!",
        systemErr: "系统异常！",
        groupErr: "获取用户组信息失败，请刷新重试！",
        placeEnter: "请填写完整表单！",
        notAllow: "您无权访问此页面",
        notAllowTip: "如有疑问，请联系系统管理员",
        statusErr: "当前订单状态已发生改变，请刷新页面后重试！",
        statusChange : "当前订单状态已发生改变，请刷新页面后重试！",
        existUser : "该用户已存在！",
    }
}
export default zh;